(function(){
    document.addEventListener('DOMContentLoaded', function () {
        CollectJS.configure({
            "paymentSelector" : "#demoPayButton",
            "variant" : "inline",
            "styleSniffer" : "false",
            "customCss":{
                "border-radius": "4px",
                "border": "solid 1px #ccc",
                "font-size": "14px",
                "padding": "0 10px ",
                "height": "42px ",
                "line-height": "42px",
                "background-color": "#F7F8FC"
            },
            "invalidCss": {
                "border-color": "red"
            },
            "validCss": {
                "color": "black",
                "border-color": "#d0ffd0"
            },
            "placeholderCss": {
                "color": "#7c7c7c",
            },
            "focusCss": {
                "outline": "#f6bc9a",
                "border-color":"#f6bc9a",
                "background-color": "white"
            },
            "fields": {
                "ccnumber": {
                    "selector": "#demoCcnumber",
                    "title": "Card Number",
                    "placeholder": "0000 0000 0000 0000"
                },
                "ccexp": {
                    "selector": "#demoCcexp",
                    "title": "Card Expiration",
                    "placeholder": "MM / YY"
                },
                "cvv": {
                    "display": "show",
                    "selector": "#demoCvv",
                    "title": "CVV Code",
                    "placeholder": "•••"
                },
            },
            'price': '1.00',
            'currency':'USD',
            'country': 'US',
            'validationCallback' : function(field, status, message) {
                if (status) {
                    var message = field + " is now OK: " + message;
                } else {
                    var message = field + " is now Invalid: " + message;
                }
                console.log(message);
            },
            "timeoutDuration" : 100000,
            "timeoutCallback" : function () {
                console.log("The tokenization didn't respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity");
            },
            "fieldsAvailableCallback" : function () {
                console.log("Collect.js loaded the fields onto the form");
            },
            'callback' : function(response) {
                // alert(response.token);
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = "cc-info-easy-pay-direct-payment-token";
                input.value = response.token;
                var form = document.getElementsByTagName("form")[0];
                form.appendChild(input);
                document.getElementById('easy-pay-direct-processing-screen').setAttribute('class','loading-screen active');
                window.JVZoo.Checkout.SubmitOrderFormAsCreditCardPayment();
                document.getElementById('demoPayButton').disabled = true;
            }
        });
        $('#apply-easy-pay-direct-checkout').on('click', function() {
            $('#cc-info-section').css('height','100%')
            $('#cc-info-section')[0].scrollIntoView({behavior:'smooth'})
        })
    });
})()